import { faUserTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY_CB,//"AIzaSyDBR-W77WeAi-fSbuNeYQfaXHsLwU8KMCM",
  authDomain: process.env.REACT_APP_AUTH_DOMAIN_CB, //"milesoft-cashbook.firebaseapp.com",
  projectId: process.env.REACT_APP_PROJECT_ID_CB, //"milesoft-cashbook",
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET_CB,//"milesoft-cashbook.appspot.com",
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID_CB,//"587751235188",
  appId: process.env.REACT_APP_APP_ID_CB,//"1:587751235188:web:af79faa5448d008bb03b21"
};

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const db = firebase.firestore();

function DeleteAccountCB() {
  const [data, setData] = useState({})
  const [user, setUser] = useState(auth.currentUser);
  const [transactions, setTransactions] = useState([]);
  const loadData = function (userId) {
    db.collection("data").doc(userId).collection("transactions").get().then(snapshot => {
      var t =[]
      snapshot.forEach(doc => {
        t.push(doc.data())
      })
      setTransactions(t);
    })
  }
  const handleChange = function (e) {
    setData({
      ...data,
      [e.target.id]: e.target.value,
    })
  }
  const handleSignIn = function (e) {
    auth.signInWithEmailAndPassword(data.email, data.password).then(result => {
      setUser(result.user);
      loadData(result.user.uid);
    })
  }
  const handleSignOut = function (e) {
    auth.signOut();
    setUser(null);
  }
  const handleDelete = function (e) {
    db.collection("data").doc(user.uid).collection("transactions").get().then(async snapshot => {
      //console.log("start deleting...")
      const batch = db.batch();
      snapshot.forEach(doc => {
        //console.log(doc.data())
        batch.delete(doc.ref);
      });
      await batch.commit()
      //console.log("done deleting.");
      handleSignOut();
    })
  }
  return (
      <div>
          <div className='jumbotron text-center bg-light border'>
            <FontAwesomeIcon icon={faUserTimes} fontSize={128} className='mb-5 text-danger'/>
        <h2>Delete Account(CashBook)</h2>
            <p>We value your privacy and data rights.</p>
          </div>
          <div className='container'>
              <div className='card bg-light p-3'>
          <div className='card-body'>
            {user ?
              <div>
                <p>Hello {user.displayName}. You have {transactions.length} transactions in your account. Please confirm deletion.</p>
                <div className='d-flex'>
                  <input type='button' className='btn btn-secondary m-1' defaultValue={"Don't Delete"} onClick={handleSignOut}/>
                  <input type='button' className='btn btn-danger m-1' defaultValue={"Delete Data"} onClick={handleDelete}/>
                </div>
              </div>
          : <div>
                <p>
              Please login to delete your account data from the CashBook mobile app.
            </p>
            <form>
              <div className='row'>
                <div className=' col form-group'>
                  <label className='form-label'>Email</label>
                  <input type='email' id='email' onChange={handleChange} className='form-control'/>
                </div>
              </div>
                <div className='row'>
                <div className=' col form-group'>
                  <label className='form-label'>Password</label>
                  <input type='password' id='password' onChange={handleChange} className='form-control'/>
                </div>
              </div>
                <div className='d-flex justify-content-end'>
                  <input type='button' onClick={handleSignIn} defaultValue="Sign In and Delete" className='btn btn-danger' />
                </div>
                      </form>
            </div>    
          }
            
                  </div>
            </div>
          </div>
          <div className='container'>&nbsp;</div>
    </div>
  )
}

export default DeleteAccountCB